import React from "react";

const viewportContext = React.createContext<{ width?: number }>({});

export const ViewportProvider: React.FC<React.PropsWithChildren<{ children: React.ReactNode }>> = ({
    children,
}) => {
    const [width, setWidth] = React.useState(window.innerWidth);

    const handleWindowResize = () => {
        setWidth(window.innerWidth);
    };

    React.useEffect(() => {
        window.addEventListener("resize", handleWindowResize);
        return () => window.removeEventListener("resize", handleWindowResize);
    }, []);

    return (
        <viewportContext.Provider value={{ width }}>
            {children}
        </viewportContext.Provider>
    );
};

const useCurrentWidth = () => {
    const { width } = React.useContext(viewportContext);

    return width;
};

export default useCurrentWidth;

export const useContainerDimensions = (
    ref: React.RefObject<HTMLHeadingElement | null>,
    deps: any[]
) => {
    const getDimensions = () =>
        ref.current
            ? {
                  width: ref.current.offsetWidth,
                  height: ref.current.offsetHeight,
              }
            : { width: 0, height: 0 };

    const [dimensions, setDimensions] = React.useState({ width: 0, height: 0 });

    const handleResize = () => {
        setDimensions(getDimensions());
    };

    React.useEffect(() => {
        if (ref.current) {
            handleResize();
        }

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [ref]);

    React.useEffect(() => {
        setTimeout(handleResize, 300);
    }, [...deps]);

    return dimensions;
};
